export const createFormData = ({
  obj,
  files
}: {
  obj: object;
  files?: { files: FileList | File; fieldName: string };
}) => {
  const data = new FormData();
  if (files) {
    const isSingleFile = (files.files as File).name;

    if (!isSingleFile) {
      Array.from(files.files as FileList).forEach((file, index) => {
        data.append(`${files.fieldName}${index}`, file);
      });
    }
    if (isSingleFile) {
      data.append(`${files.fieldName}`, files.files as File);
    }
  }

  Object.keys(obj).forEach((key) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const value = (obj as any)[key as any];

    if (value) {
      data.append(
        key,
        typeof value === "object" ? JSON.stringify(value) : value
      );
    }
  });
  return data;
};
